export const SMSMessageValidator = {
  code: {
    customValidator: (value, options = {}) => {
      const result = { is_valid: false, message: '' };
      if (options.type === 'campaign') {
        result.is_valid = true;
        return result;
      }

      if (options.type === 'transactional' && (!value || value.trim() === '')) {
        result.message = 'Code is required for transactional messages.';
        return result;
      }

      const codeRegex = /^[a-zA-Z0-9_]+$/;
      if (!codeRegex.test(value)) {
        result.message = 'Code can only contain letters, numbers, and underscores.';
        return result;
      }

      result.is_valid = true;
      return result;
    }
  },
  title: {
    required: true
  },
  audiences: {
    customValidator: (value, options = {}) => {
      const result = { is_valid: false, message: '' };
      if (options.type === 'campaign' && (!Array.isArray(value) || !value.length)) {
        result.message = 'Invalid value';
        return result;
      }

      result.is_valid = true;
      return result;
    }
  },
  message: {
    required: true
  },
  schedule: {
    customValidator: (value, options = {}) => {
      const result = { is_valid: false, message: '' };
      if (options.type === 'campaign' && isNaN(Date.parse(value))) {
        result.message = 'Invalid date';
        return result;
      }

      result.is_valid = true;
      return result;
    }
  },
  sender_id: {
    required: true,
    minLength: 3
  },
  type: {
    required: true
  }
};
